import { z } from 'zod';
import { paginationQuerySchema } from '../envelope.js';
import { uuidSchema } from './common.js';
/**
 * Akteur eines Audit-Eintrags (Spec 3.2):
 *   member:<uuid>  — handelndes Mandanten-Mitglied
 *   user:<uuid>    — Plattform-Admin ohne Mitgliedschaft im Mandanten
 *   system         — Hintergrund-Job, Cron, Migration
 *   api:<source>   — Ingest-API im Namen einer Quelle (ab Phase 3)
 */
export const auditActorSchema = z
    .string()
    .min(1)
    .max(128)
    .regex(/^(system|member:[0-9a-f-]{36}|user:[0-9a-f-]{36}|api:[a-z0-9_-]+)$/i);
export const auditLogEntrySchema = z.object({
    id: uuidSchema,
    tenant_id: uuidSchema,
    actor: auditActorSchema,
    /** Punkt-Notation, englisch: `tenant.created`, `member.role_changed`, `auth.login`. */
    action: z.string().min(1).max(120),
    entity_type: z.string().min(1).max(60),
    entity_id: uuidSchema.nullable(),
    payload: z.record(z.string(), z.unknown()),
    ip: z.string().max(64).nullable(),
    created_at: z.iso.datetime(),
});
export const auditLogQuerySchema = paginationQuerySchema.extend({
    action: z.string().max(120).optional(),
    entity_type: z.string().max(60).optional(),
    entity_id: uuidSchema.optional(),
    actor: z.string().max(128).optional(),
});
//# sourceMappingURL=audit.js.map